<template>
  <div class="Site IndexBox">
    <van-nav-bar
      fixed
      :border="false"
      :title="$t('Community[0]')"
    />
    <div class="ScrollBox">
      <div v-if="InitData.homebannerList.length" style="background-color:var(--background-main);overflow:hidden">
        <van-swipe :autoplay="3000" indicator-color="#fff" style="height: 8.5rem;margin: 10px 15px;border-radius: 10px;z-index:3">
          <van-swipe-item v-for="(item,index) in InitData.homebannerList" :key="index" @click="$router.push(item.url)">
            <img :src="InitData.setting.up_url+item.img_path" width="100%" height="100%">
          </van-swipe-item>
        </van-swipe>
      </div>
      <van-tabs v-model="tabsIndex" :ellipsis="false" :border="false" color="var(--color-active)" title-active-color="var(--color-active)" title-inactive-color="var(--color-assist)" sticky offset-top="46" @change="changeTabs">
        <van-tab v-for="tab,index in tabsList" :key="index" :title="tab.title" :name="tab.name">
          <van-pull-refresh v-model="isRefresh" @refresh="onRefresh">
            <van-list
              v-model="isLoad"
              :finished="isFinished"
              :finished-text="listData[tab.name].length?$t('vanPull[0]'):$t('vanPull[1]')"
              @load="onLoad"
              :class="{Empty:!listData[tab.name].length}"
            >
              <div v-for="item,index in listData[tab.name]" :key="index" class="msg-item">
                <div class="user">
                  <van-image :src="`./static/head/${item.header}`" round height="32" width="32" style="background-color:var(--background-assist);margin-right:10px" />
                  <div class="name">
                    <div style="display:flex;">{{item.username}}<span style="margin-left: 6px;display:flex;align-items:center;font-weight: 400;font-size: 14px;"><van-icon :name="`./static/icon/${item.vip==1?'vip-o':'vip'}.png`" />{{item.vipName}}</span></div>
                    <p>{{item.trade_time}}</p>
                  </div>
                </div>
                <div class="title">
                  {{item.directions}}
                </div>
                <!-- <div style="font-size: 12px;margin-top: 8px;">
                  {{item.directions}}
                </div> -->
                <div class="share">
                  <div v-if="item.examine_demo" class="img-list">
                    <van-image v-for="img,index in item.examine_demo" :key="index" :src="`${InitData.setting.up_url}${img}`" @click="$ImagePreview({images: [InitData.setting.up_url+img],closeable: true})" />
                  </div>
                  <a v-if="item.link" :href="item.link" target="_blank">{{item.link}}</a>
                </div>
                <div v-if="item.type=='vip'" class="footer">
                  <van-button size="mini" round color="var(--button-main)" to="/vip">{{$t('Community[3]')}}</van-button>
                  <!-- <div class="tool">
                    <a href="javascript:;">
                      <van-icon name="good-job" size="16" />
                      {{item.like}}
                    </a>
                    <a href="javascript:;">
                      <van-icon name="chat" size="16" />
                      {{item.discuss}}
                    </a>
                  </div> -->
                </div>
              </div>
            </van-list>
          </van-pull-refresh>
        </van-tab>
      </van-tabs>
    </div>
    <Footer />
  </div>
</template>

<script>
export default {
  name: 'Share',
  components: {

  },
  props: [],
  data() {
    return {
      tabsIndex: 'new',
      isLoad: false,
      isFinished: false,
      isRefresh: false,
      pageNo: 1,
      tabsList: [
        {name:'new', title: this.$t('Community[1][0]')},
        {name:'withdraw', title: this.$t('Community[1][1]')},
        {name:'vip', title: this.$t('Community[1][2]')},
        {name:'income', title: this.$t('Community[1][4]')}
      ],
      listData: {
        new: '',
        withdraw: '',
        vip: '',
        income: ''
      },
    }
  },
  computed: {

  },
  watch: {

  },
  created() {
    this.getListData()
  },
  mounted() {
    
  },
  activated() {

  },
  destroyed() {
    
  },
  methods: {
    changeTabs() {
      this.getListData()
    },
    getListData(type) {
      this.isLoad = true
      this.isRefresh = false
      if(type=='load'){
        this.pageNo+=1
      }else{
        this.pageNo = 1
        this.isFinished = false
      }
      this.$Model.GetCommunityList({type: (this.tabsIndex=='new'?'':this.tabsIndex),page_no: this.pageNo},data=>{
        this.isLoad = false
        if(data.code==1){
          if(type=='load'){
            this.listData[this.tabsIndex] = this.listData[this.tabsIndex].concat(data.list);
          }else{
            this.listData[this.tabsIndex] = data.list
          }
          if(this.pageNo==data.data_total_page){
            this.isFinished = true
          }else{
            this.isFinished = false
          }
        }else{
          this.listData[this.tabsIndex] = ''
          this.isFinished = true
        }
      })
    },
    onRefresh() {
      this.getListData()
    },
    onLoad() {
      this.getListData('load')
    },
    submitBuy(amount,grade,name) {
      const currAmount = Number(this.$store.state.InitData.UserGradeList.find(item=>item.grade==this.$store.state.UserInfo.vip_level).amount)
      if(this.$store.state.UserInfo.vip_level>grade){
        this.$toast.fail(this.$t('vip.dialog[1]',{currname: this.$store.state.UserInfo.useridentity,name: name}))
      }else{
        let html = ""
        if(this.$store.state.UserInfo.vip_level==grade){
          html = this.$t('vip.dialog[2]',{currency: this.$store.state.InitData.currency,amount: this.$Util.MoneyFormat(amount),name: name})
        }else{
          if(this.$store.state.InitData.setting.is_ck==1){
            amount = Number(amount)-currAmount
          }
          html = this.$t('vip.dialog[0]',{currency: this.$store.state.InitData.currency,amount: this.$Util.MoneyFormat(amount),name: name})
        }
        this.$Dialog.Confirm(html,()=>{
          this.$Model.BuyVip({grade:grade},data=>{
            if(data.code==1){
              this.getListData()
              this.$Model.GetUserInfo()
            }
            if(data.code==2){
              this.$router.push(`/user/recharge?vip=${grade}&amount=${Number(data.amount||amount)}`)
            }
          })
        })
      }
    },
  }
}
</script>
<style scoped>
.van-tabs>>>.van-tabs__nav{
  padding-left: 0;
  padding-right: 0;
}
.van-tabs>>>.van-tab{
  flex: none;
  padding: 0 15px;
}
.msg-item {
  background-color: var(--background-main);
  margin: 15px;
  border-radius: 10px;
  padding: 15px 12px;
  line-height: 1;
}
.msg-item .user{
  display: flex;
  align-items: center;
}
.msg-item .name{
  font-weight: 600;
  font-size: 15px;
}
.msg-item .name p{
  color: var(--color-assist);
  font-size: 12px;
  font-weight: 400;
  margin-top: 5px;
}
.msg-item .title{
  margin-top: 15px;
  font-size: 15px;
}
.msg-item .title b{
  font-size: 15px;
  color: var(--color-main);
  margin-right: 20px;
}
.msg-item .con{
  background-color: #fdfdfd;
  margin-top: 10px;
  padding: 10px;
  border-radius: 5px;
  border: 1px #f5f5f5 solid;
  display: flex;
}
.msg-item .con>img{
  margin-right: 15px;
}
.msg-item .con>div{
  flex: 1;
}
.msg-item .vip h4{
  font-weight: 600;
  font-size: 14px;
}
.msg-item .vip .flex{
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  margin-top: 10px;
}
.msg-item .vip .flex span{
  color: var(--color-assist);
}
.msg-item .vip .flex b{
  color: var(--color-important);
}
.msg-item .msg h4{
  font-size: 14px;
  margin-bottom: 15px;
}
.msg-item .msg b{
  font-size: 15px;
  color: var(--color-important);
}
.msg-item .footer{
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 10px;
}
.msg-item .tool{
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex: 1;
}
.msg-item .tool a{
  display: flex;
  align-items: center;
  margin-left: 15px;
  font-size: 12px;
  color: #c7ccd2;
}
.msg-item .tool .van-icon{
  margin-right: 5px;
}
.msg-item .share{
  background-color: #fdfdfd;
  margin-top: 10px;
  padding: 10px;
  border-radius: 5px;
  border: 1px #f5f5f5 solid;
  display: flex;
  flex-direction: column;
}
.msg-item .share>a{
  margin-top: 10px;
  color: #1989fa;
  text-decoration: underline;
  word-break: break-all;
}
.img-list{
  display: flex;
  align-items: flex-start;
  width: 100%;
  flex: none;
}
.img-list .van-image{
  max-width: 45%;
}
.img-list .van-image+.van-image{
  margin-left: 10px;
}
</style>